import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import { E取込データ種別 } from '@/openapi/enum';

export type 取込データ種別Error = {
  取込データ種別: E取込データ種別;
  errors: 取込Error[];
  page?: number;
};

export type 取込Error = {
  index?: number;
  field: string;
  message: string;
};

export default mixins(取込Mixin).extend({
  name: 'C取込Error',

  props: {
    errors: {
      type: Array as PropType<取込データ種別Error[]>,
      default: () => [],
    },
  },

  methods: {
    is固定資産台帳(取込データ種別: E取込データ種別): boolean {
      return 取込データ種別 === E取込データ種別.固定資産台帳;
    },
  },
});
